
import { FunctionComponent } from 'react';
import styles from "./AboutUs.module.css";
import Footer from '../footer/Footer';


const AboutUs: FunctionComponent = () => {
    return (

        <div className={styles.frameParent} style={{ paddingTop: "13rem" }}>
            <div className={styles.frameGroup}>
                <div className={styles.frameContainer}>
                    <div className={styles.frameDiv}>
                        <div className={styles.nextGenParent}>
                            <div className={`${styles.nextGen} `}>
                                <span>ABOUT US</span>
                            </div>
                            <div className={`${styles.nextGen1} `}>
                                <span>ABOUT US</span>
                            </div>
                            <div className={`${styles.nextGen2}`}>
                                <span>ABOUT US</span>
                            </div>
                        </div>

                        <center>
                            {/* <img src="/assets/grid.png" alt="Centered Image" style={{ marginTop: "40px" }} /> */}
                        </center>


                    </div>
                </div>
                <div className={styles.ourStory} style={{paddingBottom:"120px"}}>Our Story</div>
            
                <div className={styles.atCredresolveWe} >At CredResolve, we embarked on a mission to create lasting
                    impact in the lending ecosystem—especially for those
                    underserved or misaligned with the right credit products. While
                    lending thrives on collections, we realized that debt recovery
                    was often overlooked limiting access to credit for millions.
                    Poor collection efficiency in certain segments led to credit
                    deprivation, affecting even well deserving borrowers.
                    We saw an opportunity to bridge this gap. By reimagining
                    collections with AI-driven intelligence, automation, and a
                    seamless field force, we built a next-gen recovery
                    infrastructure that not only improves lender outcomes but also
                    enables broader financial inclusion. We believe that fixing
                    collections is the key to democratizing credit—unlocking
                    opportunities for borrowers while ensuring financial
                    institutions recover smarter, faster, and more efficiently.
                    
                </div>
                
                <div className={styles.ourVision} >Our Vision</div>
                <center>
                    <div className={styles.toBeThe} style={{ marginTop: "34px",marginBottom:"36px", width: "74%" }}>To be the most advanced, AI-driven debt recovery platform,
                        enabling fair and efficient credit access by transforming
                        collections.</div>
                </center>
                <div className={styles.ourMission}>Our Mission</div>
            </div>
            <div className={styles.weAreCommitted} style={{ width: "74%",marginTop:"20px" }}>{`We are committed to revolutionizing collections through AI, automation, and an integrated field force delivering scalable, compliant, and highly effective recovery solutions that empower lenders and drive financial inclusion. `}</div>


            <div style={{ marginTop: "190px" }} id="footer-section">
                <Footer></Footer>
            </div>
        </div>);
};

export default AboutUs;
